import { createFileRoute, Navigate } from '@tanstack/react-router'
import { minBy } from 'es-toolkit'
import { z } from 'zod'
import { useWebhooks } from '../../../../data/webhooks.tsx'
import { Webhooks } from '../../../../features/serviceManagement/webhooks/Webhooks.tsx'

const RouteComponent = () => {
	const { webhookId } = Route.useParams()

	const { data: webhooks = [], isPending } = useWebhooks()
	const selectedWebhook = webhooks.find((wh) => wh.id === webhookId)

	if (isPending) return
	if (!isPending && webhookId && !selectedWebhook) {
		return <Navigate to='/smp/webhooks/{-$webhookId}' params={{ webhookId: undefined }} search={{}} replace />
	}

	if (!isPending && !webhookId && webhooks.length > 0) {
		return (
			<Navigate to='/smp/webhooks/{-$webhookId}' params={{ webhookId: minBy(webhooks, (wh) => wh.createdAt)?.id }} search={{}} replace />
		)
	}

	return <Webhooks webhooks={webhooks} selectedWebhook={selectedWebhook} />
}

export const Route = createFileRoute('/_app/smp/webhooks/{-$webhookId}')({
	validateSearch: z.object({
		secretId: z.string().optional(),
		invocationId: z.string().optional(),
	}),
	component: RouteComponent,
})
